import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  fullHeight: {
    height: '100%',
  },
}));

export default useStyles;